import $ from 'jquery';
import './jquery-ui.min.js';
import './slider';
import './menu.js';
import './cart.js';
import './order.js';
import './product.js';
import './form.js';
import './table-of-contents.js';
import './landing-page.js';
import './modal.js';
import Gallery from './gallery.js';
import { CountUp } from 'countup.js';

$('#customer-questions').accordion({
  active: 0,
  collapsible: true,
  header: 'h3',
  heightStyle: 'content',
});

$('#js-table-of-contents').on('click', () => {
  $('#content-toc').toggleClass('show');
});

Gallery('.js-video-library-wrapper', '.js-video-library');

function mapCounters() {
  const counters = document.querySelectorAll('.counter');
  const counterMap = Array.from(counters).map((counter) => ({
    id: counter.id,
    dataCounter: Number(counter.getAttribute('data-counter')),
  }));
  return counterMap;
}
const counterMapping = mapCounters();
counterMapping?.forEach((elm) => {
  const countUp = new CountUp(elm?.id, elm?.dataCounter, {
    duration: 5,
    separator: '.',
    decimal: '.',
    enableScrollSpy: true,
    scrollSpyDelay: 500,
  });
  countUp.start();
});

window.addEventListener('scroll', function () {
  const menu = document.getElementById('js-menu-mavigation-list');
  const fixedClass = 'fixed';
  const scrolledClass = 'scrolled';
  const logo = document.querySelector('.js-logo-fixed');
  if (window.scrollY > menu.offsetTop) {
    if (!menu.classList.contains(fixedClass)) {
      const clonedLogo = logo.cloneNode(true);
      clonedLogo.classList.add('cloned-logo');
      menu.classList.add(fixedClass);
      menu.prepend(clonedLogo);
      setTimeout(() => {
        menu.classList.add(scrolledClass);
      }, 0);
    }
  } else {
    $('.cloned-logo').remove();
    menu.classList.remove(fixedClass);
    menu.classList.remove(scrolledClass);
  }
});
